module.exports = __webpack_public_path__ + "static/img/4254_phase_function_Paper_Points.4061293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4254_phase_function_Paper_Points.png
// module id = 9BR2
// module chunks = 0